// given an Id, scroll to that card
export const scrollToNote = (noteId: string): void => {
  const surface = document.getElementById('surface');
  if (!surface) return;
  const note = surface.querySelector(`#card-${noteId}`);
  if (note) note.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
